import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icons } from "@/lib/icons";

interface BrandLogoProps {
  size?: number;
  tone?: "default" | "onDark";
}

// Tuned visually so the cube glyph sits cleanly inside the plate at every
// callsite (24–32 px today). Tweak these once instead of per-size.
const RADIUS_RATIO = 0.27;
const ICON_RATIO = 0.62;
const MIN_RADIUS = 4;

/**
 * Brand mark for Sight Order — a gradient plate with a FA cube glyph.
 * Used in auth shell, sidebar, marketing nav, and footer.
 */
export function BrandLogo({ size = 26, tone = "default" }: BrandLogoProps) {
  const onDark = tone === "onDark";
  const radius = Math.max(MIN_RADIUS, Math.round(size * RADIUS_RATIO));
  const iconSize = Math.round(size * ICON_RATIO);

  return (
    <div
      aria-hidden
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background: onDark
          ? "rgba(255,255,255,0.18)"
          : "linear-gradient(135deg,var(--primary) 0%,var(--primary-deep) 50%,var(--plus) 100%)",
        border: onDark ? "1px solid rgba(255,255,255,0.3)" : "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <FontAwesomeIcon icon={Icons.brandMark} color="var(--canvas)" style={{ width: iconSize, height: iconSize }} />
    </div>
  );
}
